import { map, mergeDeepRight } from 'ramda'
import { getChanjianHomeHref, goWithTempToken } from '@/common/login'

const pages = [
  /* 短视频授权 */

  {
    path: '/videoClip/',
    name: 'video-clip-parent',
    redirect: '/videoClip/index',
    component: () => import(/* webpackChunkName: "'video-clip-parent'" */ '@/views/live-slice/index'),
    children:
      [
        /* 直播切片 */
        {
          path: 'index',
          name: 'video-clip-index',
          redirect: '/',
          meta: {
            requireLogin: false
          }
        },
        /*旧首页*/
        {
          path: 'guide',
          name: 'video-clip-guide',
          redirect: '/videoClip/index',
          meta: {
            requireLogin: false
          }
          // component: () => import(/* webpackChunkName: "video-clip-guide" */ '@/views/video-clip/guide')
        },
        /* 短视频授权-推广 */
        {
          path: 'promote-index',
          name: 'video-clip-promote-index',
          redirect: (to) => {
            // 方法接收目标路由作为参数
            // return 重定向的字符串路径/路径对象
            // checkPromote(to)
            return { name: 'video-clip-index', query: { ...(to.query ?? {}) } }
          },
          component: () =>
            import(/* webpackChunkName: "video-clip-promote-index" */ '@/views/video-clip/promote-index'),
          meta: {
            requireLogin: false
          }
        },
        {
          path: 'promote-guide',
          name: 'video-clip-promote-guide',
          redirect: '/videoClip/index',
          component: () =>
            import(/* webpackChunkName: "video-clip-promote-guide" */ '@/views/video-clip/promote-guide'),
          meta: {
            requireLogin: false
          }
        },
        /* 工作台 */
        {
          path: 'workbench',
          name: 'video-clip-workbench',
          component: () => import(/* webpackChunkName: "video-clip-workbench" */ '@/views/video-clip/index'),
          meta: {
            redirectH5PageName: 'h5-video-clip-index',
            redirectUrl: async () => {
              const url = await goWithTempToken(`${getChanjianHomeHref()}/workbench`)
              return url
            },
            showWorkbenchQrCode: true
          }
        },
        /* 工作台-空 */
        {
          path: 'empty-workbench',
          name: 'video-clip-empty-workbench',
          component: () =>
            import(/* webpackChunkName: "video-clip-empty-workbench" */ '@/views/video-clip/empty-workbench'),
          meta: {
            redirectH5PageName: 'h5-video-clip-index',
            redirectUrl: async () => {
              const url = await goWithTempToken(`${getChanjianHomeHref()}/workbench`)
              return url
            },
            showWorkbenchQrCode: true
          }
        },
        /* 补充资料 */
        {
          path: 'supplementary',
          name: 'video-clip-supplementary',
          component: () =>
            import(/* webpackChunkName: "video-clip-supplementary" */ '@/views/video-clip/supplementary')
        },
        {
          path: 'apply',
          name: 'video-clip-apply',
          component: () => import(/* webpackChunkName: "live-slice-apply" */ '@/views/live-slice/apply')
        },
        {
          path: 'help',
          name: 'video-clip-help',
          component: () => import(/* webpackChunkName: "live-slice-help" */ '@/views/live-slice/help'),
          meta: {
            requireLogin: false
          }
        }
      ] |> map(mergeDeepRight({ meta: { requireLogin: true, redirectH5PageName: 'h5-video-clip-home' } })),
    meta: {
      requireLogin: false,
      notShowSide: true
    }
  }
]

export default pages
  |> map(mergeDeepRight({ meta: { requireLogin: true, redirectH5PageName: 'h5-video-clip-home' } }))
